import * as TYPE from '../types';
import { ProfileAction, ProfilesActions, ProfilesState, UserType } from '../types';

interface ProfilesReducerState {
  profiles: ProfilesState;
  user: UserType;
};

const initialState: ProfilesReducerState = {
  profiles: {},
  user: {} as UserType
};
export default (state = initialState, action: ProfilesActions) => {
  switch (action.type) {
    case ProfileAction.UPDATE_PROFILES:
      return { ...action.data };
    default:
      return state;
  }
};
